import service from './axios';
export const getActivities = (params = {}) => service.get('/manage/activities', { params });
export const getActivity = (id) => service.get(`/manage/activities/${id}`);
export const createActivity = (d) => service.post('/manage/activities', d);
export const updateActivity = (id, d) => service.put(`/manage/activities/${id}`, d);
export const deleteActivity = (id) => service.delete(`/manage/activities/${id}`);
export const getActivityRegistrations = (activityId, params) => {
  const url = activityId ? `/manage/activities/${activityId}/registrations` : '/manage/activity-registrations';
  return service.get(url, { params });
};
export const verifyRegistration = (id) => service.put(`/manage/activity-registrations/${id}/verify`);
